export var uiAngleLeft = [
    'M6.34 7.8L9.1 5.08C9.21 4.97 9.39 4.97 9.5 5.08L9.66 5.25C9.77 5.36 9.77 5.54 9.66 5.65L7.27 8L9.66 10.35C9.77 10.46 9.77 10.64 9.66 10.75L9.49 10.92C9.38 11.03 9.21 11.03 9.1 10.92L6.34 8.2C6.23 8.09 6.23 7.91 6.34 7.8Z',
];
